import { useState, useRef, useCallback, useEffect } from 'react';
import useApiFetch from '@/hooks/useApiFetch';
import useFocus from '@/hooks/useFocus';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import jobsService from '@/services/jobs';
import { FetchApiIds } from '@/types';
import JobSearchComponent from './JobSearch.component';

const JobSearch = (props): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const isInputSearchFocused = useFocus(inputRef);

  const [isJobSearchListVisible, setJobSearchListVisible] = useState<boolean>(true);
  const [wordToSearch, setWordToSearch] = useState<string>('');

  useEffect(() => {
    if (isInputSearchFocused) {
      setJobSearchListVisible(true);
    }
  }, [isInputSearchFocused]);

  const hideJobSearchList = useCallback((event: any) => {
    const eventPath = event.composedPath() ?? [];
    const componentIDs = ['job-search-input', 'job-search-list'];
    const checkPathId = (path): boolean => componentIDs.includes(path.id);
    const hasClickedInsideComponent = eventPath.some(checkPathId);

    if (!hasClickedInsideComponent) {
      setJobSearchListVisible(false);
    }
  }, []);

  useOnClickOutside(containerRef, hideJobSearchList);

  const jobSearchResponse = useApiFetch(
    [FetchApiIds.JOB_SEARCH, wordToSearch],
    async () => jobsService.searchJob(wordToSearch),
    { enabled: wordToSearch.length >= 2 }
  );

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const {
      target: { value },
    } = event;

    setWordToSearch(value);
  };

  return (
    <JobSearchComponent
      {...props}
      isLoading={jobSearchResponse.isLoading}
      hasError={jobSearchResponse.isError}
      hasFetched={jobSearchResponse.isFetched}
      jobs={jobSearchResponse.data ?? []}
      onChangeHandler={onChangeHandler}
      value={wordToSearch}
      containerRef={containerRef}
      ref={inputRef}
      isJobSearchListVisible={isJobSearchListVisible}
    />
  );
};

export default JobSearch;
